import * as fromDatatype from "../datatype-library/index";

export interface bl_del_job_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_trip_hdr: fromDatatype.GuidDataFieldInterface;
  running_number_01: fromDatatype.VarcharDatatypeInterface;
  running_number_02: fromDatatype.VarcharDatatypeInterface;
  running_number_03: fromDatatype.VarcharDatatypeInterface;
  shipment_type: fromDatatype.VarcharDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  duration_minute: fromDatatype.IntegerDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  label_list_guid: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  guid_region_hdr: fromDatatype.GuidDataFieldInterface;
  from_branch_guid: fromDatatype.GuidDataFieldInterface;
  to_branch_guid: fromDatatype.GuidDataFieldInterface;
  from_location_guid: fromDatatype.GuidDataFieldInterface;
  to_location_guid: fromDatatype.GuidDataFieldInterface;
  from_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
  to_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
  logistic_ref_no_1: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_2: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_3: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_4: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_5: fromDatatype.TextDatatypeInterface;
  sender_ref_no_1: fromDatatype.TextDatatypeInterface;
  sender_ref_no_2: fromDatatype.TextDatatypeInterface;
  sender_ref_no_3: fromDatatype.TextDatatypeInterface;
  sender_ref_no_4: fromDatatype.TextDatatypeInterface;
  sender_ref_no_5: fromDatatype.TextDatatypeInterface;
  sender_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sender_customer_code: fromDatatype.TextDatatypeInterface;
  sender_supplier_code: fromDatatype.TextDatatypeInterface;
  sender_name: fromDatatype.TextDatatypeInterface;
  sender_email: fromDatatype.TextDatatypeInterface;
  sender_phone_no: fromDatatype.TextDatatypeInterface;
  sender_address_1: fromDatatype.TextDatatypeInterface;
  sender_address_2: fromDatatype.TextDatatypeInterface;
  sender_address_3: fromDatatype.TextDatatypeInterface;
  sender_address_4: fromDatatype.TextDatatypeInterface;
  sender_address_5: fromDatatype.TextDatatypeInterface;
  sender_city: fromDatatype.TextDatatypeInterface;
  sender_postcode: fromDatatype.TextDatatypeInterface;
  sender_state: fromDatatype.TextDatatypeInterface;
  sender_country: fromDatatype.TextDatatypeInterface;
  sender_pickup_from_datetime_from: fromDatatype.TimestampTzDatatypeInterface;
  sender_pickup_from_datetime_to: fromDatatype.TimestampTzDatatypeInterface;
  recipient_ref_no_1: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_2: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_3: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_4: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_5: fromDatatype.TextDatatypeInterface;
  recipient_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recipient_name: fromDatatype.TextDatatypeInterface;
  recipient_email: fromDatatype.TextDatatypeInterface;
  recipient_phone_no: fromDatatype.TextDatatypeInterface;
  recipient_address_1: fromDatatype.TextDatatypeInterface;
  recipient_address_2: fromDatatype.TextDatatypeInterface;
  recipient_address_3: fromDatatype.TextDatatypeInterface;
  recipient_address_4: fromDatatype.TextDatatypeInterface;
  recipient_address_5: fromDatatype.TextDatatypeInterface;
  recipient_city: fromDatatype.TextDatatypeInterface;
  recipient_postcode: fromDatatype.TextDatatypeInterface;
  recipient_state: fromDatatype.TextDatatypeInterface;
  recipient_country: fromDatatype.TextDatatypeInterface;
  recipient_customer_code: fromDatatype.VarcharDatatypeInterface;
  from_branch_code: fromDatatype.VarcharDatatypeInterface;
  to_branch_code: fromDatatype.VarcharDatatypeInterface;
  from_location_code: fromDatatype.VarcharDatatypeInterface;
  to_location_code: fromDatatype.VarcharDatatypeInterface;
  from_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
  to_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
  delivery_status: fromDatatype.VarcharDatatypeInterface;
  ext_delivery_status: fromDatatype.VarcharDatatypeInterface;
  delivery_logic: fromDatatype.VarcharDatatypeInterface;
  ext_delivery_json: fromDatatype.JsonDatatypeInterface;
  process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_status_guid: fromDatatype.GuidDataFieldInterface;
  process_status_name: fromDatatype.VarcharDatatypeInterface;
  process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  ext_cod_type: fromDatatype.VarcharDatatypeInterface;
  ext_cod_currency: fromDatatype.VarcharDatatypeInterface;
  ext_cod_amount: fromDatatype.NumericDatatypeInterface;
  logistic_provider_guid: fromDatatype.GuidDataFieldInterface;
  ext_pkg_no_of_parts: fromDatatype.NumericDatatypeInterface;
  ext_shipment_weight: fromDatatype.NumericDatatypeInterface;
  ext_shipment_height: fromDatatype.NumericDatatypeInterface;
  ext_shipment_length: fromDatatype.NumericDatatypeInterface;
  ext_shipment_width: fromDatatype.NumericDatatypeInterface;
  ext_shipment_volumetric_weight: fromDatatype.NumericDatatypeInterface;
  ext_seller_id: fromDatatype.VarcharDatatypeInterface;
  ext_content: fromDatatype.VarcharDatatypeInterface;
  ext_contact_person: fromDatatype.VarcharDatatypeInterface;
  ext_shipment_type: fromDatatype.VarcharDatatypeInterface;
  ext_ccy_code: fromDatatype.VarcharDatatypeInterface;
  ext_amount_fee: fromDatatype.NumericDatatypeInterface;
  pickup_date_estimated: fromDatatype.TimestampTzDatatypeInterface;
  pickup_date_planned: fromDatatype.TimestampTzDatatypeInterface;
  pickup_date_actual: fromDatatype.TimestampTzDatatypeInterface;
  pickup_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_estimated: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_planned: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_actual: fromDatatype.TimestampTzDatatypeInterface;
  pkg_no_of_parts: fromDatatype.NumericDatatypeInterface;
  airway_bill_no: fromDatatype.VarcharDatatypeInterface;
  consignment_json: fromDatatype.JsonDatatypeInterface;
  tracking_status: fromDatatype.JsonDatatypeInterface;
  consignment_status: fromDatatype.JsonDatatypeInterface;
  airway_bill_status: fromDatatype.JsonDatatypeInterface;
  request_body_json: fromDatatype.JsonDatatypeInterface;
  proof_rct_name: fromDatatype.VarcharDatatypeInterface;
  proof_rct_id: fromDatatype.VarcharDatatypeInterface;
  proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
  proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
  collection_amount: fromDatatype.NumericDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
  ext_print_format: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  shipment_value: fromDatatype.NumericDatatypeInterface;
  request_status: fromDatatype.VarcharDatatypeInterface;
  sequence_in_trip: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  shipment_est_time_arrival: fromDatatype.TimestampTzDatatypeInterface;
  shipment_est_time_berthing: fromDatatype.TimestampTzDatatypeInterface;
  shipment_time_completion: fromDatatype.TimestampTzDatatypeInterface;
  shipment_time_depart: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_del_job_hdr_RowClass implements bl_del_job_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  guid_trip_hdr: fromDatatype.GuidDataFieldInterface;
  running_number_01: fromDatatype.VarcharDatatypeInterface;
  running_number_02: fromDatatype.VarcharDatatypeInterface;
  running_number_03: fromDatatype.VarcharDatatypeInterface;
  shipment_type: fromDatatype.VarcharDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  duration_minute: fromDatatype.IntegerDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  label_list_guid: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  guid_region_hdr: fromDatatype.GuidDataFieldInterface;
  from_branch_guid: fromDatatype.GuidDataFieldInterface;
  to_branch_guid: fromDatatype.GuidDataFieldInterface;
  from_location_guid: fromDatatype.GuidDataFieldInterface;
  to_location_guid: fromDatatype.GuidDataFieldInterface;
  from_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
  to_logistic_hub_guid: fromDatatype.GuidDataFieldInterface;
  logistic_ref_no_1: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_2: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_3: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_4: fromDatatype.TextDatatypeInterface;
  logistic_ref_no_5: fromDatatype.TextDatatypeInterface;
  sender_ref_no_1: fromDatatype.TextDatatypeInterface;
  sender_ref_no_2: fromDatatype.TextDatatypeInterface;
  sender_ref_no_3: fromDatatype.TextDatatypeInterface;
  sender_ref_no_4: fromDatatype.TextDatatypeInterface;
  sender_ref_no_5: fromDatatype.TextDatatypeInterface;
  sender_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sender_customer_code: fromDatatype.TextDatatypeInterface;
  sender_supplier_code: fromDatatype.TextDatatypeInterface;
  sender_name: fromDatatype.TextDatatypeInterface;
  sender_email: fromDatatype.TextDatatypeInterface;
  sender_phone_no: fromDatatype.TextDatatypeInterface;
  sender_address_1: fromDatatype.TextDatatypeInterface;
  sender_address_2: fromDatatype.TextDatatypeInterface;
  sender_address_3: fromDatatype.TextDatatypeInterface;
  sender_address_4: fromDatatype.TextDatatypeInterface;
  sender_address_5: fromDatatype.TextDatatypeInterface;
  sender_city: fromDatatype.TextDatatypeInterface;
  sender_postcode: fromDatatype.TextDatatypeInterface;
  sender_state: fromDatatype.TextDatatypeInterface;
  sender_country: fromDatatype.TextDatatypeInterface;
  sender_pickup_from_datetime_from: fromDatatype.TimestampTzDatatypeInterface;
  sender_pickup_from_datetime_to: fromDatatype.TimestampTzDatatypeInterface;
  recipient_ref_no_1: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_2: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_3: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_4: fromDatatype.TextDatatypeInterface;
  recipient_ref_no_5: fromDatatype.TextDatatypeInterface;
  recipient_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  recipient_name: fromDatatype.TextDatatypeInterface;
  recipient_email: fromDatatype.TextDatatypeInterface;
  recipient_phone_no: fromDatatype.TextDatatypeInterface;
  recipient_address_1: fromDatatype.TextDatatypeInterface;
  recipient_address_2: fromDatatype.TextDatatypeInterface;
  recipient_address_3: fromDatatype.TextDatatypeInterface;
  recipient_address_4: fromDatatype.TextDatatypeInterface;
  recipient_address_5: fromDatatype.TextDatatypeInterface;
  recipient_city: fromDatatype.TextDatatypeInterface;
  recipient_postcode: fromDatatype.TextDatatypeInterface;
  recipient_state: fromDatatype.TextDatatypeInterface;
  recipient_country: fromDatatype.TextDatatypeInterface;
  recipient_customer_code: fromDatatype.VarcharDatatypeInterface;
  from_branch_code: fromDatatype.VarcharDatatypeInterface;
  to_branch_code: fromDatatype.VarcharDatatypeInterface;
  from_location_code: fromDatatype.VarcharDatatypeInterface;
  to_location_code: fromDatatype.VarcharDatatypeInterface;
  from_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
  to_logistic_hub_code: fromDatatype.VarcharDatatypeInterface;
  delivery_status: fromDatatype.VarcharDatatypeInterface;
  ext_delivery_status: fromDatatype.VarcharDatatypeInterface;
  delivery_logic: fromDatatype.VarcharDatatypeInterface;
  ext_delivery_json: fromDatatype.JsonDatatypeInterface;
  process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  process_status_guid: fromDatatype.GuidDataFieldInterface;
  process_status_name: fromDatatype.VarcharDatatypeInterface;
  process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  ext_cod_type: fromDatatype.VarcharDatatypeInterface;
  ext_cod_currency: fromDatatype.VarcharDatatypeInterface;
  ext_cod_amount: fromDatatype.NumericDatatypeInterface;
  logistic_provider_guid: fromDatatype.GuidDataFieldInterface;
  ext_pkg_no_of_parts: fromDatatype.NumericDatatypeInterface;
  ext_shipment_weight: fromDatatype.NumericDatatypeInterface;
  ext_shipment_height: fromDatatype.NumericDatatypeInterface;
  ext_shipment_length: fromDatatype.NumericDatatypeInterface;
  ext_shipment_width: fromDatatype.NumericDatatypeInterface;
  ext_shipment_volumetric_weight: fromDatatype.NumericDatatypeInterface;
  ext_seller_id: fromDatatype.VarcharDatatypeInterface;
  ext_content: fromDatatype.VarcharDatatypeInterface;
  ext_contact_person: fromDatatype.VarcharDatatypeInterface;
  ext_shipment_type: fromDatatype.VarcharDatatypeInterface;
  ext_ccy_code: fromDatatype.VarcharDatatypeInterface;
  ext_amount_fee: fromDatatype.NumericDatatypeInterface;
  pickup_date_estimated: fromDatatype.TimestampTzDatatypeInterface;
  pickup_date_planned: fromDatatype.TimestampTzDatatypeInterface;
  pickup_date_actual: fromDatatype.TimestampTzDatatypeInterface;
  pickup_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_estimated: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_planned: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  delivery_date_actual: fromDatatype.TimestampTzDatatypeInterface;
  pkg_no_of_parts: fromDatatype.NumericDatatypeInterface;
  airway_bill_no: fromDatatype.VarcharDatatypeInterface;
  consignment_json: fromDatatype.JsonDatatypeInterface;
  tracking_status: fromDatatype.JsonDatatypeInterface;
  consignment_status: fromDatatype.JsonDatatypeInterface;
  airway_bill_status: fromDatatype.JsonDatatypeInterface;
  request_body_json: fromDatatype.JsonDatatypeInterface;
  proof_rct_name: fromDatatype.VarcharDatatypeInterface;
  proof_rct_id: fromDatatype.VarcharDatatypeInterface;
  proof_rct_phone: fromDatatype.VarcharDatatypeInterface;
  proof_rct_remarks: fromDatatype.VarcharDatatypeInterface;
  collection_amount: fromDatatype.NumericDatatypeInterface;
  reason: fromDatatype.VarcharDatatypeInterface;
  ext_print_format: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  shipment_value: fromDatatype.NumericDatatypeInterface;
  request_status: fromDatatype.VarcharDatatypeInterface;
  sequence_in_trip: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  shipment_est_time_arrival: fromDatatype.TimestampTzDatatypeInterface;
  shipment_est_time_berthing: fromDatatype.TimestampTzDatatypeInterface;
  shipment_time_completion: fromDatatype.TimestampTzDatatypeInterface;
  shipment_time_depart: fromDatatype.TimestampTzDatatypeInterface;
}
